var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        mousedown: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onCancel.apply(null, arguments)
        },
        dragover: function ($event) {
          $event.preventDefault()
        },
        drop: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c("div", { staticClass: "import-dialog" }, [
        _c("div", { staticClass: "import-header" }, [
          _c("span", { staticClass: "import-header-title" }, [
            _vm._v(_vm._s(_vm.$t("homePage.import.dialogTitle"))),
          ]),
          _c(
            "button",
            {
              staticClass: "import-close-button",
              attrs: { type: "button" },
              on: { click: _vm.onCancel },
            },
            [_c("IconClose", { staticClass: "import-close-icon" })],
            1
          ),
        ]),
        _c(
          "div",
          {
            staticClass: "dropzone",
            attrs: {
              "data-dragover": _vm.isDragOver ? "true" : "false",
              "data-error": _vm.errorMessage ? "true" : "false",
            },
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.onDropzoneClick.apply(null, arguments)
              },
              dragenter: function ($event) {
                $event.preventDefault()
                return _vm.onDragEnter.apply(null, arguments)
              },
              dragover: function ($event) {
                $event.preventDefault()
              },
              dragleave: function ($event) {
                $event.preventDefault()
                return _vm.onDragLeave.apply(null, arguments)
              },
              drop: function ($event) {
                $event.preventDefault()
                return _vm.onDrop.apply(null, arguments)
              },
            },
          },
          [
            _c("input", {
              ref: "folderInput",
              staticClass: "dropzone-input",
              attrs: {
                type: "file",
                webkitdirectory: "",
                tabindex: "-1",
                "aria-hidden": "true",
              },
              on: { change: _vm.onFolderInputChange },
            }),
            _c("input", {
              ref: "fileInput",
              staticClass: "dropzone-input",
              attrs: {
                type: "file",
                accept: ".txt,.docx",
                multiple: "",
                tabindex: "-1",
                "aria-hidden": "true",
              },
              on: { change: _vm.onFileInputChange },
            }),
            _vm.isBusy
              ? _c("div", { staticClass: "dropzone-placeholder" }, [
                  _c("span", { staticClass: "dropzone-label" }, [
                    _vm._v(_vm._s(_vm.$t("homePage.import.loading"))),
                  ]),
                ])
              : !_vm.hasSelection
              ? _c(
                  "div",
                  {
                    staticClass: "dropzone-placeholder is-clickable",
                    on: { click: _vm.selectFile },
                  },
                  [
                    _c("IconUpload", { staticClass: "dropzone-icon" }),
                    _c(
                      "i18n",
                      {
                        staticClass: "dropzone-label",
                        attrs: {
                          path: "homePage.import.dropzoneLabel",
                          tag: "p",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "import-trigger-wrap",
                            attrs: { place: "action" },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "import-trigger",
                                attrs: {
                                  type: "button",
                                  "aria-haspopup": "menu",
                                  "aria-expanded": _vm.isMenuOpen
                                    ? "true"
                                    : "false",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.toggleMenu.apply(null, arguments)
                                  },
                                  keydown: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "esc",
                                        27,
                                        $event.key,
                                        ["Esc", "Escape"]
                                      )
                                    )
                                      return null
                                    return _vm.closeMenu.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "homePage.import.dropzoneLabelAction"
                                      )
                                    ) +
                                    " "
                                ),
                                _c("IconChevronDown", {
                                  staticClass: "import-trigger-icon",
                                }),
                              ],
                              1
                            ),
                            _vm.isMenuOpen
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "import-menu",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "esc",
                                            27,
                                            $event.key,
                                            ["Esc", "Escape"]
                                          )
                                        )
                                          return null
                                        return _vm.closeMenu.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        ref: "firstMenuItem",
                                        staticClass: "import-menu-item",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.selectFolder.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("IconFolder", {
                                          staticClass: "import-menu-item-icon",
                                        }),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "homePage.import.selectFolder"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "import-menu-item",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.selectFile.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("IconFile", {
                                          staticClass: "import-menu-item-icon",
                                        }),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "homePage.import.selectFile"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "dropzone-selected" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "dropzone-clear-button",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.$t(
                            "homePage.import.clearSelection"
                          ),
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.clearSelection.apply(null, arguments)
                          },
                        },
                      },
                      [_c("IconTrash", { staticClass: "dropzone-clear-icon" })],
                      1
                    ),
                    _c("IconCheck", { staticClass: "dropzone-check" }),
                    _c("span", { staticClass: "dropzone-selected-text" }, [
                      _vm._v(_vm._s(_vm.selectedSummary)),
                    ]),
                  ],
                  1
                ),
            _vm.errorMessage
              ? _c("p", { staticClass: "dropzone-error" }, [
                  _vm._v(_vm._s(_vm.errorMessage)),
                ])
              : _vm._e(),
          ]
        ),
        _vm.isMenuOpen
          ? _c("div", {
              staticClass: "import-menu-backdrop",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.closeMenu.apply(null, arguments)
                },
              },
            })
          : _vm._e(),
        _c("p", { staticClass: "import-description" }, [
          _vm._v(_vm._s(_vm.$t("homePage.import.description"))),
        ]),
        !_vm.hideScriptMode
          ? _c("div", { staticClass: "script-mode-section" }, [
              _c("label", { staticClass: "toggle-row" }, [
                _c("span", { staticClass: "toggle-switch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.isScriptMode,
                        expression: "isScriptMode",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.isScriptMode)
                        ? _vm._i(_vm.isScriptMode, null) > -1
                        : _vm.isScriptMode,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.isScriptMode,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.isScriptMode = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.isScriptMode = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.isScriptMode = $$c
                        }
                      },
                    },
                  }),
                  _c("span", { staticClass: "toggle-slider" }),
                ]),
                _c("span", { staticClass: "toggle-label" }, [
                  _vm._v(_vm._s(_vm.$t("homePage.import.scriptModeLabel"))),
                ]),
              ]),
              _c("div", { staticClass: "toggle-description" }, [
                _c("p", { staticClass: "toggle-description-text" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("novelCreatePage.scriptMode.description")) +
                      " "
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "toggle-link",
                      attrs: { type: "button" },
                      on: { click: _vm.showScriptModeHelp },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("novelCreatePage.scriptMode.learnMore")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "import-button",
            attrs: { type: "button", disabled: !_vm.canImport },
            on: { click: _vm.onClickImport },
          },
          [_vm._v(" " + _vm._s(_vm.$t("homePage.import.importButton")) + " ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }